import React from "react";
import Helpers from "../Utils/Helpers.js";
import {withStyles} from '@material-ui/core/styles';
import Typography from "@material-ui/core/es/Typography/Typography";
import {NewButton, SoldButton, ReducedButton} from "./Buttons.js";
import moment from 'moment';

const styles = theme => ({
    root: {
        color: "#0c5460",
        backgroundColor: "#d1ecf1",
        borderColor: "#bee5eb",
        marginBottom: "1rem",
        border: "1px solid transparent",
        borderRadius: ".25rem",
        padding: ".75rem 1.25rem"
    }
});

function SearchResultHighlight(elementProps) {

    const {classes, element} = elementProps;

    let price = null;
    if (element.salePrice > 0 && element.salePrice !== element.price) {
        price =
            <Typography variant='h5'>
                <strike>${Helpers.formatMoney(element.price)}</strike> ${Helpers.formatMoney(element.salePrice)}<br/>
            </Typography>
    } else if (element.price > 0) {
        price = <Typography variant='h5'>${Helpers.formatMoney(element.price)}<br/></Typography>
    } else {
        price = null;
    }

    let extraFeatures = element.extraFields.filter(entry => entry.showOnResults && entry.value.length > 0).map((extraField, index) => {
        return <React.Fragment key={extraField.name}><strong>{extraField.name}</strong> {extraField.value}<br /></React.Fragment>;
    });

    let nowDate = moment();
    let newButton = nowDate.diff(element.dateStarted, 'days') < 7 ?
        <React.Fragment><NewButton /><br/></React.Fragment> :
        null;

    let reducedButton = element.isReduced ?
        <React.Fragment><ReducedButton/><br/></React.Fragment> :
        null;

    let soldButton = element.isSold ?
        <React.Fragment><SoldButton/><br/></React.Fragment> :
        null;

        let distance = null;
        if (element.distance > 0) {
            distance = <React.Fragment>{element.distance.toFixed(2)} miles away<br/></React.Fragment>
        }



    if (element.price === 0 &&
        element.salePrice === 0 &&
        element.distance === 0 &&
        (element.extraFields.length === 0 || !element.extraFields.some(x=>x.value)) &&
        soldButton === null &&
        reducedButton === null &&
        newButton === null
    ) {
        return "";
    }


        return (
        <div className={classes.root}>
            {price}
            <Typography key={1} variant="body1">{extraFeatures}</Typography>
            {newButton}{reducedButton}{soldButton}
            <Typography key={2} variant="body1">{distance}</Typography>
        </div>
    )
}

export default withStyles(styles)(SearchResultHighlight);